const fr = {
  nav: {
    home: 'Accueil',
    products: 'Nos Produits',
    about: 'À Propos',
    contact: 'Contact',
  },
  home: {
    hero: {
      eyebrow: 'Kits Finishers & Textiles Techniques',
      title1: 'ÉQUIPEZ VOS',
      title2: 'ÉVÉNEMENTS SPORTIFS',
      subtitle: 'Médailles, textiles et accessoires personnalisés pour les organisateurs d\'événements sportifs en Belgique et en France.',
      cta1: 'Découvrir les packs',
      cta2: 'Demander un devis',
    },
    problems: {
      title: 'Le défi de l\'organisateur',
      pain_title: 'Les problèmes récurrents',
      solution_title: 'L\'approche Ultra Sport',
      pains: [
        'Délais de livraison non tenus',
        'Qualité décevante à la réception',
        'Interlocuteur non spécialisé sport',
        'Aucun suivi personnalisé',
        'Surprises de dernière minute',
        'Logistique multi-fournisseurs complexe',
      ],
      solutions: [
        'Planning inversé garanti',
        'Produits testés et validés terrain',
        'Expert événements sportifs',
        'Un interlocuteur du devis à la livraison',
        'BAT validé avant chaque production',
        'Livraison toujours comprise',
      ],
    },
    packs: {
      title: 'Nos Packs Complets',
      subtitle: 'De l\'essentiel au premium, une solution pour chaque événement',
      cta: 'Voir le détail complet',
      see_all: 'Voir tous les produits',
      essential: {
        name: 'Pack Finisher Essentiel',
        participants: '200 – 800 participants',
        tagline: 'Simple, efficace, budget maîtrisé',
        items: [
          'Gobelet trail',
          'Casquette Lifestyle ou sport',
          'Chaussettes Course et Vélo',
          'Flasque 500 ml',
          '... (tous vos projets sont réalisables)',
        ],
      },
      performance: {
        name: 'Pack Performance',
        participants: '800 – 1500+ participants',
        badge: 'RECOMMANDÉ',
        tagline: 'Idéal Trail et Triathlon',
        loyalty: '2ème commande -20%',
        items: [
          'Médaille finisher 6cm et ruban sublimation 2.5 cm',
          'Casquette Lifestyle et Sport',
          'Flasque trail',
          'Sac à dos',
          '... Tous vos projets sont réalisables',
        ],
      },
      premium: {
        name: 'Pack Premium',
        participants: '1500 – 2000+ participants',
        tagline: 'Image forte et souvenir durable',
        loyalty: '2ème -20%, 3ème -30%',
        items: [
          'Gobelet trail',
          'Buff Ice Silk premium',
          'Casquette Brodée',
          'Flasque Trail',
          'Sac à dos',
          '... Tous vos projets sont réalisables',
        ],
      },
    },
    vip: {
      title: 'L\'Expérience VIP pour vos Participants',
      formula: 'UltraTiming + Ultra Sport = Distribution VIP Setup',
      description: 'Combinez le chronométrage expert d\'UltraTiming avec les kits premium d\'Ultra Sport pour offrir une expérience finisher inoubliable.',
      timing_label: 'Chronométrage expert & résultats temps réel',
      goodies_label: 'Kits finishers premium & distribution organisée',
      result_label: 'Événement VIP complet',
      discover: 'Découvrir UltraTiming.live',
    },
    clients: {
      title: 'Ils Nous Font Confiance',
      subtitle: 'Plus de 18 événements sportifs nous ont confié leurs kits finishers',
    },
    promo: {
      badge: 'OFFRE SPÉCIALE',
      text: 'Pack Finisher T-shirt + Médaille à partir de',
      price: '6,50€ HTVA',
      cta: 'Demander un devis',
    },
    why_choose: {
      eyebrow: 'Pourquoi nous choisir ?',
      title: '6 Raisons de choisir Ultra Sport',
    },
    stats: {
      events: { value: 150, suffix: '+', label: 'Événements équipés' },
      delivery: { value: 100, suffix: '%', label: 'Livraison à temps' },
      participants: { value: 50000, suffix: '+', label: 'Participants satisfaits' },
      expertise: { value: 2015, suffix: '', label: "Depuis" },
    },
    reasons: {
      planning: { title: 'Planning Garanti', desc: 'Livraison assurée avant votre événement, sans surprise' },
      quality: { title: 'Qualité Testée', desc: 'Produits validés sur le terrain par des sportifs' },
      expert: { title: 'Expert Sport', desc: 'Spécialiste événements sportifs depuis 2015' },
      contact: { title: 'Interlocuteur Unique', desc: 'Un seul contact du devis à la livraison' },
      bat: { title: 'BAT Validé', desc: 'Bon à tirer approuvé avant chaque production' },
      delivery: { title: 'Livraison Incluse', desc: 'Transport toujours compris, pas de frais cachés' },
    },
    contact: {
      title: 'Demander un Devis',
      subtitle: 'Parlez-nous de votre événement — réponse garantie sous 24h',
      nom: 'Nom',
      prenom: 'Prénom',
      email: 'Email',
      event_name: 'Nom de l\'événement',
      participants: 'Nombre de participants',
      pack_choice: 'Choix du pack',
      event_date: 'Date de l\'événement',
      message: 'Message',
      pack_options: ['Pack Finisher Essentiel', 'Pack Performance', 'Pack Premium', 'Offre Spéciale T-shirt + Médaille', 'Sur devis personnalisé'],
      submit: 'Envoyer la demande',
      sending: 'Envoi en cours...',
      success: 'Votre demande a bien été envoyée ! Nous vous recontactons sous 24h.',
      error: 'Une erreur est survenue. Veuillez réessayer.',
    },
  },
  products: {
    title: 'Nos Produits',
    subtitle: 'Catalogue complet des kits finishers et textiles techniques',
    packs_title: 'Nos Packs Complets',
    packs_subtitle: 'Des solutions clés en main pour chaque événement',
    catalog_title: 'Nos Réalisations',
    catalog_subtitle: 'Découvrez nos créations personnalisées',
    planning_title: 'Planning Inversé',
    planning_subtitle: 'Calculez vos délais — livraison safe garantie',
    quality_title: 'Qualité Garantie',
    quality_badge: 'Aucun produit n\'intègre notre catalogue sans avoir été testé et validé en interne par l\'équipe UltraTiming',
    request_quote: 'Demander un devis',
    products_included: 'Produits inclus',
    services_included: 'Services inclus',
    ideal_for: 'Idéal pour',
    na: 'N/A',
    filters: {
      all: 'Tous',
      textile: 'Textile',
      medals: 'Médailles',
      hydration: 'Hydratation',
      accessories: 'Accessoires',
      bags: 'Sacs',
      packaging: 'Packaging',
    },
    packs: {
      essential: {
        name: 'Pack Finisher Essentiel',
        badge: 'ESSENTIEL',
        participants: '200 – 800 participants',
        tagline: 'Simple, efficace, budget maîtrisé',
        services: [
          'Design graphique inclus (1 proposition + retouches)',
          'BAT obligatoire avant production',
          'Lancement production après validation',
          'Livraison toujours comprise',
          'Délai réaliste garanti (planning inversé)',
        ],
        products: [
          'Gobelet trail',
          'Casquette Lifestyle ou sport',
          'Chaussettes Course et Vélo',
          'Flasque 500 ml',
          '... (tous vos projets sont réalisables)',
        ],
      },
      performance: {
        name: 'Pack Performance',
        badge: '★ RECOMMANDÉ ★',
        participants: '800 – 1500+ participants',
        tagline: 'Idéal Trail et Triathlon',
        loyalty: '2ème commande : -20%',
        services: [
          'Design graphique inclus (1 proposition + retouches)',
          'BAT validé obligatoire',
          'Lancement production',
          'Livraison comprise',
          '2ème goodies : -20% sur la commande',
        ],
        products: [
          'Médaille finisher 6cm et ruban sublimation 2.5 cm',
          'Casquette Lifestyle et Sport',
          'Flasque trail',
          'Sac à dos',
          '... Tous vos projets sont réalisables',
        ],
      },
      premium: {
        name: 'Pack Premium',
        badge: 'PREMIUM',
        participants: '1500 – 2000+ participants recommandé',
        tagline: 'Image forte et souvenir durable',
        loyalty: '2ème -20% | 3ème -30%',
        services: [
          'Design graphique inclus (2 propositions + retouches)',
          'BAT validé obligatoire',
          'Lancement production',
          'Livraison comprise',
          '2ème goodies : -20%',
          '3ème goodies : -30%',
        ],
        products: [
          'Gobelet trail',
          'Buff Ice Silk premium',
          'Casquette Brodée',
          'Flasque Trail',
          'Sac à dos',
          '... Tous vos projets sont réalisables',
        ],
      },
    },
    quality: {
      medals_title: 'Médailles',
      medals_text: 'Alliage zinc robuste, finitions contrôlées, relief/émaillage/découpe, validation BAT précise',
      textile_title: 'Textile',
      textile_text: 'Sublimation résistante, tissu respirant sport, tailles unisexes optimisées, mêmes producteurs que Compressport',
      accessories_title: 'Accessoires',
      accessories_text: 'Matières certifiées alimentaires, résistantes, testées terrain trail/running/triathlon',
    },
    planning_note: '10 jours ouvrables entre devis signé et lancement production. Format = jours production + jours livraison.',
    planning_products: {
      tshirt: 'T-shirt technique',
      cup: 'Gobelet / Flasque',
      buff: 'Buff / Tour de cou',
      cap: 'Casquette',
      socks: 'Chaussettes hautes',
      medal: 'Médaille',
      backpack: 'Sac à dos',
      packaging: 'Packaging premium',
    },
    items: {
      tshirt_210: { name: 'T-shirt Technique 210gr', desc: 'Polyester 100% respirant, 210gr/m², sublimation 1 couleur, coupe unisexe XS à 3XL', ideal: 'Événements budget, grandes quantités', packs: 'Essentiel' },
      tshirt_110: { name: 'T-shirt Technique 110gr Gaufré', desc: 'Polyester gaufré ultra-léger, sublimation intégrale, tissu mesh respirant, XS à 3XL', ideal: 'Trail, triathlon, running longue durée', packs: 'Performance & Premium' },
      medal_6cm: { name: 'Médaille Finisher 6cm', desc: 'Alliage zinc robuste, relief gravé, ruban sublimé 2cm personnalisé, BAT obligatoire', ideal: 'Événements 800–1500+ participants', packs: 'Performance' },
      medal_7cm: { name: 'Médaille Finisher 7cm Premium', desc: 'Alliage zinc, finitions premium, ruban sublimé 3cm, émaillage et découpe spéciale possible', ideal: 'Événements prestige 1500+ participants', packs: 'Premium' },
      medal_custom: { name: 'Médaille Sur Mesure', desc: 'Forme libre, dimensions sur demande, finitions multiples (doré, argenté, bronze, émaillée)', ideal: 'Événements avec identité forte', packs: 'Sur devis' },
      cup_silicon: { name: 'Gobelet Pliable Silicone', desc: 'Silicone alimentaire certifié BPA free, 150ml ou 200ml, logo 1–3 couleurs, clip fixation', ideal: 'Trail, running, événements éco-responsables', packs: 'Tous packs' },
      cup_pp: { name: 'Gobelet Réutilisable PP', desc: 'Polypropylène BPA free, 25cl ou 33cl, logo 1–3 couleurs, rigide et empilable', ideal: 'Distribution dossards, économique', packs: 'Tous packs' },
      flask_150: { name: 'Flasque Trail Souple 150ml', desc: 'TPU souple certifié alimentaire, bouchon bite valve anti-fuite, logo 1–3 couleurs', ideal: 'Trail, running, compatible ceinture hydratation', packs: 'Tous packs' },
      flask_250: { name: 'Flasque Trail Souple 250ml', desc: 'TPU souple certifié alimentaire, bouchon bite valve, logo 1–3 couleurs', ideal: 'Trail longue distance, triathlon', packs: 'Tous packs' },
      buff_poly: { name: 'Buff / Tour de Cou Polyester', desc: 'Polyester 100% léger, full print sublimation, taille universelle, 12 façons de porter', ideal: 'Événements toutes saisons', packs: 'Essentiel' },
      buff_icesilk: { name: 'Buff / Tour de Cou Ice Silk', desc: 'Matière fraîche au toucher, effet refroidissant, full print sublimation haute définition', ideal: 'Été, trail chaud, triathlon', packs: 'Performance & Premium' },
      cap_5p_1c: { name: 'Casquette 5 Panneaux — 1 Couleur', desc: 'Polyester/coton respirant, visière courbée, velcro ou snapback, sérigraphie 1 couleur', ideal: 'Événements budget', packs: 'Essentiel' },
      cap_56p_2c: { name: 'Casquette 5/6 Panneaux — 2 Couleurs', desc: 'Polyester respirant, anti-UV possible, velcro/snapback/élastique, sérigraphie 2 couleurs', ideal: 'Trail, triathlon', packs: 'Performance' },
      cap_emb: { name: 'Casquette Brodée 2 Couleurs', desc: 'Polyester premium ou coton peigné, broderie haute qualité 2 couleurs, finition premium', ideal: 'Image de marque premium', packs: 'Premium' },
      socks: { name: 'Chaussettes Sport Hautes', desc: 'Polyester/élasthanne, renforts talon et pointe, logo jacquard 1–2 couleurs, tailles 35–46', ideal: 'Trail, running, triathlon, longue distance', packs: 'Tous packs' },
      backpack: { name: 'Sac à Dos Trail/Sport Léger', desc: 'Nylon léger 5–10L, logo 2 couleurs, bretelles rembourrées, compatible poche hydratation', ideal: 'Trail longue distance, souvenir mémorable', packs: 'Performance & Premium' },
      totebag: { name: 'Sac Tote Bag Non Tissé', desc: 'Polypropylène recyclable 38x42cm, logo 1 couleur, distribution dossards', ideal: 'Goodies bag, distribution dossards', packs: 'Sur devis' },
      sachet_zip: { name: 'Sachet Zip Transparent Personnalisé', desc: 'Plastique transparent avec zip, logo + nom événement, tailles S/M/L', ideal: 'Présentation premium de chaque kit', packs: 'Premium' },
      box_premium: { name: 'Boîte Carton Premium', desc: 'Carton rigide finition mate ou brillante, full print extérieur, taille sur mesure', ideal: 'Expérience participant haut de gamme', packs: 'Premium — sur devis' },
    },
  },
  about: {
    title: 'À Propos',
    subtitle: 'L\'expert des kits finishers pour les événements sportifs',
    story_title: 'Notre Histoire',
    story_text: 'Ultra Sport est née d\'une passion pour les événements sportifs et d\'une frustration partagée par de nombreux organisateurs : trouver un fournisseur fiable, spécialisé, qui comprend les contraintes uniques du monde sportif. Fondée par l\'équipe UltraTiming, nous avons mis notre expertise du terrain au service des organisateurs d\'événements en Belgique et en France. Chaque produit de notre catalogue a été testé et validé lors d\'épreuves réelles avant d\'être proposé.',
    values_title: 'Nos Valeurs',
    values: [
      { title: 'Fiabilité', text: 'Nos engagements sont tenus. Délais, qualité et communication : nous ne faisons aucun compromis sur ce qui compte le jour J.' },
      { title: 'Expertise Sport', text: 'Nous connaissons les événements sportifs de l\'intérieur. Trail, triathlon, running : nous vivons ce monde depuis des années.' },
      { title: 'Qualité Testée', text: 'Chaque produit est testé sur le terrain avant d\'entrer dans notre catalogue. Zéro surprise le jour de votre événement.' },
      { title: 'Partenariat Durable', text: 'Partenaire à long terme, fidélité récompensée. -20% dès la 2ème commande, -30% à la 3ème. On grandit ensemble.' },
    ],
    partnership_title: 'Notre Partenariat UltraTiming',
    partnership_text: 'Ultra Sport est la branche goodies et textiles d\'UltraTiming, spécialiste européen du chronométrage d\'épreuves sportives. Cette synergie unique nous permet de comprendre parfaitement les besoins des organisateurs et d\'offrir une solution événement complète.',
    partnership_cta: 'Découvrir UltraTiming.live',
    clients_title: 'Ils Nous Font Confiance',
    clients_subtitle: 'Des événements de toutes tailles nous font confiance pour leurs kits finishers',
    cta_title: 'Prêt à équiper votre événement ?',
    cta_text: 'Contactez-nous pour un devis personnalisé. Réponse sous 24h garantie.',
    cta_button: 'Demander un devis',
  },
  footer: {
    tagline: 'L\'équipement officiel de vos événements sportifs',
    contact_email: 'info@ultrasport.live',
    ultratiming: 'Visitez UltraTiming.live',
    copyright: '© 2026 Ultra Sport – Sports Event Goodies. Tous droits réservés.',
  },
};

export default fr;
